(function (cjs, an) {

var p; // shortcut to reference prototypes
var lib={};var ss={};var img={};
lib.ssMetadata = [
		{name:"index_atlas_1", frames: [[414,65,45,78],[295,0,121,63],[0,65,288,63],[0,195,270,63],[261,325,176,63],[272,195,174,63],[0,0,293,63],[0,325,259,63],[0,130,284,63],[0,260,262,63],[290,65,122,63]]}
];


(lib.AnMovieClip = function(){
	this.actionFrames = [];
	this.ignorePause = false;
	this.gotoAndPlay = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndPlay.call(this,positionOrLabel);
	}
	this.play = function(){
		cjs.MovieClip.prototype.play.call(this);
	}
	this.gotoAndStop = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndStop.call(this,positionOrLabel);
	}
	this.stop = function(){
		cjs.MovieClip.prototype.stop.call(this);
	}
}).prototype = p = new cjs.MovieClip();
// symbols:



(lib.CachedBmp_62 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(0);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_61 = function() {
	this.initialize(img.CachedBmp_61);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,2573,40);


(lib.CachedBmp_60 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(1);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_59 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(2);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_58 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(3);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_57 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(4);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_56 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(5);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_55 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(6);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_54 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(7);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_53 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(8);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_52 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(9);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_51 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(10);
}).prototype = p = new cjs.Sprite();
// helper functions:

function mc_symbol_clone() {
	var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop, this.reversed));
	clone.gotoAndStop(this.currentFrame);
	clone.paused = this.paused;
	clone.framerate = this.framerate;
	return clone;
}

function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
	var prototype = cjs.extend(symbol, cjs.MovieClip);
	prototype.clone = mc_symbol_clone;
	prototype.nominalBounds = nominalBounds;
	prototype.frameBounds = frameBounds;
	return prototype;
	}


(lib.stripe = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// stripe
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#07504F").beginStroke().moveTo(-41,45).lineTo(-41,-45).lineTo(41,-45).lineTo(41,45).closePath();

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-41,-45,82.1,90);


(lib.sign_out_text = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// SignOutText
	this.instance = new lib.CachedBmp_62();
	this.instance.setTransform(0,-0.9,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.sign_out_text, new cjs.Rectangle(0,-0.9,22.5,39), null);


(lib.sign_out_background = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// SignOutBackground
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#720F11").beginStroke().moveTo(-20,30).lineTo(-20,-30).lineTo(20,-30).lineTo(20,30).closePath();
	this.shape.setTransform(20,30);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.sign_out_background, new cjs.Rectangle(0,0,40,60), null);


(lib.pseudo_after = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// MenuPseudoAfter
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("rgba(149,93,85,0.498)").beginStroke().moveTo(-78.5,30).lineTo(-78.5,-30).lineTo(78.6,-30).lineTo(78.6,30).closePath();
	this.shape.setTransform(78.55,30);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.pseudo_after, new cjs.Rectangle(0,0,157.1,60), null);


(lib.menu_line_solid = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// line
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill().beginStroke("#A26A0F").setStrokeStyle(2,0,1).moveTo(-960,0).lineTo(960,0);
	this.shape.setTransform(960,0);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.menu_line_solid, new cjs.Rectangle(-1,-1,1922,2), null);


(lib.menu_line_gradient = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// line
	this.shape = new cjs.Shape();
	this.shape.graphics.beginLinearGradientFill(["#5BC3BE","#1F4F6E"],[0,1],-680,0,680,0).beginStroke().moveTo(-680,1).lineTo(-680,-1).lineTo(680,-1).lineTo(680,1).closePath();
	this.shape.setTransform(680,1);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.menu_line_gradient, new cjs.Rectangle(0,0,1360,2), null);


(lib.logo_large = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// logo_mask (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-151.9,35).lineTo(-151.9,-35).lineTo(151.9,-35).lineTo(151.9,35).closePath();
	mask.setTransform(151.9,35);

	// logo
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#BBA467").beginStroke().moveTo(109.4,68.7).curveTo(106.8,67.3,105.5,64.6).lineTo(107.9,63.2).curveTo(109,65.2,111,66.2).curveTo(113.1,67.2,115.4,67.3).curveTo(116.6,67.2,117.6,67.1).curveTo(118.5,67,119.7,66.4).curveTo(120.7,65.9,121.3,65.1).curveTo(121.9,64.2,121.9,62.9).curveTo(121.9,61.9,121.4,61.1).curveTo(120.9,60.4,119.9,60).lineTo(117.8,59.2).lineTo(112.6,58.3).lineTo(110.2,57.5).curveTo(109.1,57.1,108.2,56.4).curveTo(107.4,55.6,106.9,54.7).curveTo(106.4,53.7,106.4,52.3).curveTo(106.4,50.5,107.2,49.2).curveTo(108,48,109.4,47.2).curveTo(110.7,46.5,112.2,46.2).curveTo(113.6,45.8,115.3,45.8).curveTo(118.3,45.8,120.5,46.7).curveTo(122.7,47.6,124.1,50).lineTo(121.9,51.3).curveTo(121,49.9,119.2,49.2).curveTo(117.5,48.4,115.4,48.3).curveTo(112.9,48.3,111.1,49.4).curveTo(109.3,50.4,109.3,52.3).curveTo(109.3,53.2,109.7,53.9).curveTo(110.1,54.5,111.2,55).lineTo(113.1,55.7).lineTo(118.4,56.6).curveTo(119.4,56.9,120.8,57.4).curveTo(122.2,57.9,122.9,58.6).curveTo(123.7,59.2,124.2,60.4).curveTo(124.8,61.5,124.8,63).curveTo(124.8,65.1,123.9,66.3).curveTo(123.1,67.7,121.7,68.4).curveTo(120.3,69.3,118.7,69.6).curveTo(117.2,69.9,115.3,69.9).curveTo(112.1,70,109.4,68.7).closePath().moveTo(77.1,69).curveTo(74.8,67.9,73.4,66.2).curveTo(72,64.7,71.2,62.4).curveTo(70.5,60.3,70.5,58).curveTo(70.5,52.8,73.7,49.3).curveTo(76.9,45.9,82.3,45.9).curveTo(87.8,45.9,91,49.4).curveTo(94.1,53.1,94,58).curveTo(94,60.3,93.3,62.4).curveTo(92.5,64.7,91.1,66.2).curveTo(89.7,67.9,87.4,69).curveTo(85.1,70,82.3,69.9).curveTo(79.5,70,77.1,69).closePath().moveTo(75.7,51.2).curveTo(73.3,54,73.3,58).curveTo(73.3,61.7,75.7,64.5).curveTo(78,67.2,82.3,67.3).curveTo(86.5,67.2,88.9,64.5).curveTo(91.1,61.7,91.1,58).curveTo(91.2,55.5,90.3,53.5).curveTo(89.3,51.4,87.3,50).curveTo(85.1,48.6,82.3,48.5).curveTo(78.1,48.5,75.7,51.2).closePath().moveTo(55.4,69.5).lineTo(48.2,61.1).lineTo(42.6,61.1).lineTo(42.6,69.5).lineTo(39.7,69.5).lineTo(39.7,46.3).lineTo(50.2,46.3).curveTo(54,46.3,56,48.4).curveTo(58.1,50.7,58.1,53.7).curveTo(58.2,56.6,56.5,58.6).curveTo(54.8,60.7,51.4,60.9).lineTo(59.1,69.5).closePath().moveTo(42.6,58.5).lineTo(50.1,58.5).curveTo(52.6,58.5,53.9,57.2).curveTo(55.2,55.8,55.2,53.8).curveTo(55.2,51.8,53.9,50.3).curveTo(52.6,48.9,50.2,48.9).lineTo(42.6,48.9).closePath().moveTo(22,69.5).lineTo(22,46.3).lineTo(24.9,46.3).lineTo(24.9,69.5).closePath().moveTo(-8.2,69.5).lineTo(-8.2,46.3).lineTo(8.1,46.3).lineTo(8.1,49).lineTo(-5.3,49).lineTo(-5.3,56.2).lineTo(7.6,56.2).lineTo(7.6,58.9).lineTo(-5.3,58.9).lineTo(-5.3,66.7).lineTo(8.7,66.7).lineTo(8.7,69.5).closePath().moveTo(-25.8,69.5).lineTo(-25.8,59).lineTo(-39.1,59).lineTo(-39.1,69.5).lineTo(-42,69.5).lineTo(-42,46.3).lineTo(-39.1,46.3).lineTo(-39.1,56.4).lineTo(-25.8,56.4).lineTo(-25.8,46.3).lineTo(-22.9,46.3).lineTo(-22.9,69.5).closePath().moveTo(-58.7,69.5).lineTo(-73,51.8).lineTo(-73,69.5).lineTo(-75.8,69.5).lineTo(-75.8,46.3).lineTo(-73.8,46.3).lineTo(-59.6,64).lineTo(-59.6,46.3).lineTo(-56.8,46.3).lineTo(-56.8,69.5).closePath().moveTo(-93.5,69.5).lineTo(-93.5,46.3).lineTo(-90.6,46.3).lineTo(-90.6,69.5).closePath().moveTo(-124.8,69.5).lineTo(-124.8,46.3).lineTo(-114.3,46.3).curveTo(-111.9,46.3,-110.4,47.2).curveTo(-108.6,48,-107.7,49.4).curveTo(-106.8,50.8,-106.4,52.5).curveTo(-106,54.2,-106.4,55.8).curveTo(-106.8,57.5,-107.7,58.9).curveTo(-108.6,60.3,-110.4,61.1).curveTo(-112,62,-114.3,62).lineTo(-122,62).lineTo(-122,69.5).closePath().moveTo(-122,59.3).lineTo(-114.3,59.3).curveTo(-112.6,59.3,-111.4,58.5).curveTo(-110.2,57.8,-109.7,56.6).curveTo(-109.2,55.5,-109.2,54.1).curveTo(-109.2,52.8,-109.7,51.7).curveTo(-110.2,50.5,-111.4,49.8).curveTo(-112.6,49,-114.3,49).lineTo(-122,49).closePath().moveTo(-303.6,-69.9).lineTo(-289.3,-69.9).curveTo(-262.2,-69.9,-262.2,-53.5).curveTo(-262.2,-46.7,-267.2,-42.5).curveTo(-269.6,-40.5,-272.5,-39.5).curveTo(-267.9,-38.1,-264.7,-35.4).curveTo(-259,-30.3,-259,-22.8).curveTo(-259,-18.2,-260.9,-14.6).lineTo(-275.4,-13.6).curveTo(-272.5,-16.8,-272.5,-23).curveTo(-272.5,-29.7,-276,-32.8).curveTo(-279.7,-35.9,-289,-35.9).lineTo(-290.9,-35.9).lineTo(-290.9,-12.4).lineTo(-303.6,-11.3).closePath().moveTo(-290.9,-63.9).lineTo(-290.9,-41.8).lineTo(-290.6,-41.8).curveTo(-281.7,-41.8,-278.6,-44.4).curveTo(-275.6,-46.9,-275.6,-53).curveTo(-275.6,-57.1,-276.8,-59.5).curveTo(-278.1,-61.6,-280.3,-62.6).curveTo(-282.5,-63.9,-288.9,-64).lineTo(-290.9,-63.9).closePath().moveTo(289.6,-12.6).curveTo(292.7,-15.2,293,-18.7).curveTo(293.4,-22.4,291.2,-25.1).curveTo(288.8,-28,281.5,-32.1).curveTo(274.5,-36,271.1,-38.7).curveTo(267.5,-41.6,265.6,-46).curveTo(263.7,-50.2,264.3,-55).curveTo(265,-62.1,270.5,-66.3).curveTo(275.9,-70.4,283.4,-69.7).curveTo(287.3,-69.3,291,-67.6).curveTo(294.5,-65.9,299,-59.7).lineTo(294,-55.6).curveTo(291.8,-59,291.3,-59.5).curveTo(288.2,-63.3,283.3,-63.8).curveTo(278.9,-64.2,276.8,-62.3).curveTo(274.6,-60.2,274.3,-57.5).curveTo(273.9,-54.3,276.2,-51.7).curveTo(278.5,-48.9,286,-44.5).curveTo(293.7,-39.9,296.6,-37.8).curveTo(300.3,-34.9,302.1,-30.7).curveTo(304,-26.4,303.5,-21).curveTo(302.9,-15.7,300,-11.7).closePath().moveTo(266.3,-14.3).curveTo(263.9,-16.7,262.3,-19.3).lineTo(266.6,-23.9).curveTo(269.8,-19.3,272.2,-16.9).curveTo(274.6,-14.5,277.2,-13.5).closePath().moveTo(-210.7,-69.9).lineTo(-198,-69.9).lineTo(-198,-18).lineTo(-210.7,-17.4).closePath().moveTo(198.3,-18).lineTo(200.5,-18.9).curveTo(204.8,-20.8,206.6,-23.5).curveTo(208.9,-26.6,209.2,-29.1).curveTo(210.1,-34.3,210.1,-39.2).lineTo(210.1,-69.9).lineTo(216,-69.9).lineTo(216,-38.9).curveTo(216,-33.2,215.1,-27).curveTo(214.4,-23.1,210.8,-18.7).lineTo(209.7,-17.5).closePath().moveTo(166.7,-19.2).lineTo(165.6,-20.9).curveTo(162.6,-26.4,163.1,-33.7).lineTo(163.5,-40).lineTo(163.5,-69.9).lineTo(176.1,-69.9).lineTo(176.1,-39.7).lineTo(176.2,-31.1).curveTo(176.4,-27.2,176.7,-25.9).curveTo(177.4,-22.2,180.8,-19.7).curveTo(181.6,-19.1,182.6,-18.6).closePath().moveTo(-150.3,-37.6).curveTo(-150.3,-52.3,-140.5,-61.1).curveTo(-135.4,-65.7,-130.6,-67.7).curveTo(-125.2,-69.9,-118.1,-69.9).curveTo(-111,-69.9,-105.7,-67.8).curveTo(-100.8,-65.8,-95.6,-61.3).curveTo(-85.6,-52.3,-85.6,-37.2).curveTo(-85.6,-28.2,-89.3,-21.2).lineTo(-101.7,-21).curveTo(-99.6,-26.4,-99.6,-37.2).curveTo(-99.6,-44.5,-100.5,-49).curveTo(-101.5,-54.1,-104,-57.2).curveTo(-106.6,-60.7,-109.8,-62.3).curveTo(-113.2,-63.9,-118.1,-64).curveTo(-122.8,-63.9,-125.7,-62.4).curveTo(-128.3,-61,-131.1,-57.5).curveTo(-136.4,-50.8,-136.4,-37.2).curveTo(-136.4,-26.7,-133.2,-20.2).lineTo(-145.8,-19.9).curveTo(-150.3,-27.4,-150.3,-37.6).closePath().moveTo(101.6,-21).lineTo(99.1,-27).lineTo(79.1,-27).lineTo(76.9,-21.4).lineTo(70.1,-21.5).lineTo(90.1,-69.9).lineTo(94.4,-69.9).lineTo(115.4,-20.7).closePath().moveTo(81.3,-32.8).lineTo(96.8,-32.8).lineTo(88.9,-51.8).closePath().moveTo(-37.5,-69.9).lineTo(-24.8,-69.9).lineTo(-24.8,-41.7).lineTo(4.4,-41.7).lineTo(4.4,-69.9).lineTo(17.1,-69.9).lineTo(17.1,-21.9).lineTo(4.4,-21.9).lineTo(4.4,-35.8).lineTo(-24.8,-35.8).lineTo(-24.8,-21.9).lineTo(-37.5,-21.9).closePath();
	this.shape.setTransform(151.9374,35.0714,0.5003,0.5004);

	var maskedShapeInstanceList = [this.shape];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	// size
	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.beginFill("rgba(255,255,255,0)").beginStroke().moveTo(-151.9,35).lineTo(-151.9,-35).lineTo(151.9,-35).lineTo(151.9,35).closePath();
	this.shape_1.setTransform(151.9,35);

	this.timeline.addTween(cjs.Tween.get(this.shape_1).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.logo_large, new cjs.Rectangle(0,0,303.8,70), null);


(lib.botoes = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FFFFFF").beginStroke().moveTo(-236.1,78).lineTo(-236.1,-78).lineTo(236.1,-78).lineTo(236.1,78).closePath();
	this.shape.setTransform(236.05,78.025);
	this.shape._off = true;

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(3).to({_off:false},0).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,472.1,156.1);


(lib.background_effect = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_19 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).wait(19).call(this.frame_19).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,0,0);


(lib.background_dynamic = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(10));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,0,0);


(lib.background = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,0,0);


(lib.arrow = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// arrow
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#B49F6C").beginStroke().moveTo(-14.5,7.3).lineTo(0,-7.2).lineTo(14.5,7.3).closePath();
	this.shape.setTransform(0,-3.5);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-14.5,-10.7,29,14.5);


(lib.stripe_up = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"in":0,out:10};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_9 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
		
		/**
		 *
		 * Class reference.
		 */
		const AllTapParent = window.parent.AllTap;
		
		
		AllTapParent.emit('animateend', {in: true});
	}
	this.frame_19 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
		
		/**
		 *
		 * Class reference.
		 */
		const AllTapParent = window.parent.AllTap;
		
		
		AllTapParent.emit('animateend', {out: true});
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).wait(9).call(this.frame_9).wait(10).call(this.frame_19).wait(1));

	// stripe
	this.instance = new lib.stripe("synched",0);
	this.instance.setTransform(0,45);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({y:-40},5).to({y:-35},2).to({y:-45},2).to({startPosition:0},1).to({y:-35},2).to({y:-40},2).to({y:45},5).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-41,-90,82.1,180);


(lib.menu_background = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// menu_line_solid
	this.instance = new lib.menu_line_solid();
	this.instance.setTransform(960,-80,1,1,0,0,0,960,0);
	this.instance.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// menu_line_gradient
	this.instance_1 = new lib.menu_line_gradient();
	this.instance_1.setTransform(1240,-79,1,1,0,0,0,680,1);
	this.instance_1.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	// background
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#F5F3D6").beginStroke().moveTo(-960,40).lineTo(-960,-40).lineTo(960,-40).lineTo(960,40).closePath();
	this.shape.setTransform(960,-40);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.menu_background, new cjs.Rectangle(-1,-81,1922,81), null);


(lib.arrow_up = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_9 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).wait(9).call(this.frame_9).wait(1));

	// arrow
	this.instance = new lib.arrow("synched",0);
	this.instance.setTransform(0,12);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({y:-26},5).to({y:-12},2).to({x:0.3,y:-18.4},2).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-14.5,-36.7,29.3,52.5);


(lib.menu_marker = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {capa:0,localizacao:1,projeto:2,diferenciais:3,implantacoes:4,plantas:5,imagens:6,tour:7,institucional:8,video:9};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(10));

	// arrow_up
	this.occ_animate = new lib.arrow_up();
	this.occ_animate.name = "occ_animate";
	this.occ_animate.setTransform(40.55,0);

	this.timeline.addTween(cjs.Tween.get(this.occ_animate).wait(1).to({x:171.75},0).wait(1).to({x:343.4},0).wait(1).to({x:514.25},0).wait(1).to({x:687.35},0).wait(1).to({x:839.2},0).wait(1).to({x:961.9},0).wait(1).to({x:1108.75},0).wait(1).to({x:1283.45},0).wait(1).to({x:1420.75},0).wait(1));

	// stripe_up
	this.occ_animate_1 = new lib.stripe_up();
	this.occ_animate_1.name = "occ_animate_1";
	this.occ_animate_1.setTransform(36.05,0,0.8782,1);
	this.occ_animate_1.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.occ_animate_1).to({_off:true},1).wait(9));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,1435.3,90);


// stage content:
(lib.index = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this.actionFrames = [0];
	this.isSingleFrame = false;
	// timeline functions:
	this.frame_0 = function() {
		if(this.isSingleFrame) {
			return;
		}
		if(this.totalFrames == 1) {
			this.isSingleFrame = true;
		}
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
		
		/**
		 *
		 * Class reference.
		 */
		const 
			AllTap = window.AllTap,
			name_current = 'index';
		
		/**
		 *
		 *  @param object
		 *  Set "this", object of canvas CreateJs.
		 */
		AllTap.setState({...AllTap.state, [`_this_${name_current}`]: this});
		
		/**
		 *
		 * @param array
		 *  [{
		 *      name: {string} = Name of occurrence not prefixed here "btn_".
		 *      occ_logo_large: {boolean} = Is visible (optional) !this is hide by default.
		 *      occ_logo_medium: {boolean} = Is visible (optional) !this is hide by default.
		 *      occ_logo_small: {boolean} = Is visible (optional) !this is hide by default.
		 *      occ_background: {boolean} = Is visible (optional) !this is hide by default.
		 *      occ_background_dynamic: {boolean} = Is visible (optional), go to label current !this is hide by default.
		 *      occ_background_effect: {boolean} = Is visible (optional), auto executable movie clip in frame 0 !this is hide by default.
		 *      occ_external: {boolean} = Is visible (optional), open in new page target="_blank".
		 *      occ_video: {boolean} = Is button video, run outside the iFrame (optional).
		 *      occ_tour: {boolean} = Is button tour, run outside the iFrame (optional).
		 *            src: URL of external and video or tour.
		 *      page_default: {boolean} = Define function $page_default() "root", finish of video (optional).
		 *  }]
		 */
		AllTap.createMenu([
		    {
		        name: 'capa',
				occ_logo_small: false,
		        page_default: true,
				occ_background_dynamic: true
		    },
		    {
		        name: 'localizacao',
				occ_logo_small: true
		    },
		    {
		        name: 'projeto',
				occ_logo_small: true
		    },
		    {
		        name: 'diferenciais',
				occ_logo_small: true
		    },
		    {
		        name: 'implantacoes',
				occ_logo_small: true
		    },
		    {
		        name: 'plantas',
				occ_logo_small: true
		    },
		    {
		        name: 'imagens',
				occ_logo_small: true
		    },
		    {
		        name: 'tour',
				occ_logo_small: true,
				occ_tour: true,
				src: 'https://xp.neorama.com/projetos/GD8/'
				
		    },
			{
		        name: 'institucional',
				occ_logo_small: true
		    },
			{
		        name: 'video',
				occ_logo_small: true,
				occ_video: true,
				src: './public/media/biohaus.mp4'
		    }
		]);
		/*this.btSair.addEventListener("click", fl_sair);
		
		function fl_sair() {
			window.open("./../../index.html", "_self");
		}*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(1));

	// BackgroundEffect
	this.occ_background_effect = new lib.background_effect();
	this.occ_background_effect.name = "occ_background_effect";
	this.occ_background_effect.setTransform(8.2,0.25);

	this.timeline.addTween(cjs.Tween.get(this.occ_background_effect).wait(1));

	// LogoLarge
	this.occ_logo_large = new lib.logo_large();
	this.occ_logo_large.name = "occ_logo_large";
	this.occ_logo_large.setTransform(54.45,1011.75,0.8453,0.8454,0,0,0,0.1,0.3);
	this.occ_logo_large.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.occ_logo_large).wait(1));

	// LogoSmall
	this.occ_logo_small = new lib.logo_large();
	this.occ_logo_small.name = "occ_logo_small";
	this.occ_logo_small.setTransform(54.45,1011.75,0.8453,0.8454,0,0,0,0.1,0.3);
	this.occ_logo_small.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.occ_logo_small).wait(1));

	// SignOutButton
	this.btn_sign_out = new lib.botoes();
	this.btn_sign_out.name = "btn_sign_out";
	this.btn_sign_out.setTransform(1870,1000,0.1059,0.5127);
	new cjs.ButtonHelper(this.btn_sign_out, 0, 1, 2, false, new lib.botoes(), 3);

	this.timeline.addTween(cjs.Tween.get(this.btn_sign_out).wait(1));

	// sign_out_text
	this.instance = new lib.sign_out_text();
	this.instance.setTransform(1888.85,1021.3);
	this.instance.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// sign_out_background
	this.instance_1 = new lib.sign_out_background();
	this.instance_1.setTransform(1880,1010);
	this.instance_1.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	// MenuButton
	this.btn_tour = new lib.botoes();
	this.btn_tour.name = "btn_tour";
	this.btn_tour.setTransform(1381.45,1010,0.3286,0.3843,0,0,0,0.9,0);
	new cjs.ButtonHelper(this.btn_tour, 0, 1, 2, false, new lib.botoes(), 3);

	this.btn_video = new lib.botoes();
	this.btn_video.name = "btn_video";
	this.btn_video.setTransform(1730.8,1010,0.1702,0.3843,0,0,0,1.4,0);
	new cjs.ButtonHelper(this.btn_video, 0, 1, 2, false, new lib.botoes(), 3);

	this.btn_institucional = new lib.botoes();
	this.btn_institucional.name = "btn_institucional";
	this.btn_institucional.setTransform(1551.85,1010,0.3471,0.3843,0,0,0,1,0);
	new cjs.ButtonHelper(this.btn_institucional, 0, 1, 2, false, new lib.botoes(), 3);

	this.btn_plantas = new lib.botoes();
	this.btn_plantas.name = "btn_plantas";
	this.btn_plantas.setTransform(1135.9,1010,0.2264,0.3843,0,0,0,0.9,0);
	new cjs.ButtonHelper(this.btn_plantas, 0, 1, 2, false, new lib.botoes(), 3);

	this.btn_capa = new lib.botoes();
	this.btn_capa.name = "btn_capa";
	this.btn_capa.setTransform(350.2,1010,0.1718,0.3843,0,0,0,1.4,0);
	new cjs.ButtonHelper(this.btn_capa, 0, 1, 2, false, new lib.botoes(), 3);

	this.btn_localizacao = new lib.botoes();
	this.btn_localizacao.name = "btn_localizacao";
	this.btn_localizacao.setTransform(446.45,1010,0.3197,0.3846,0,0,0,0.7,0);
	new cjs.ButtonHelper(this.btn_localizacao, 0, 1, 2, false, new lib.botoes(), 3);

	this.btn_projeto = new lib.botoes();
	this.btn_projeto.name = "btn_projeto";
	this.btn_projeto.setTransform(612.5,1010,0.3431,0.3846,0,0,0,0.3,0);
	new cjs.ButtonHelper(this.btn_projeto, 0, 1, 2, false, new lib.botoes(), 3);

	this.btn_imagens = new lib.botoes();
	this.btn_imagens.name = "btn_imagens";
	this.btn_imagens.setTransform(1257.95,1010,0.2291,0.3843,0,0,0,0.7,0);
	new cjs.ButtonHelper(this.btn_imagens, 0, 1, 2, false, new lib.botoes(), 3);

	this.btn_implantacoes = new lib.botoes();
	this.btn_implantacoes.name = "btn_implantacoes";
	this.btn_implantacoes.setTransform(954.3,1010,0.3525,0.3843,0,0,0,0.6,0);
	new cjs.ButtonHelper(this.btn_implantacoes, 0, 1, 2, false, new lib.botoes(), 3);

	this.btn_diferenciais = new lib.botoes();
	this.btn_diferenciais.name = "btn_diferenciais";
	this.btn_diferenciais.setTransform(789.7,1010,0.3163,0.3843,0,0,0,0.5,0);
	new cjs.ButtonHelper(this.btn_diferenciais, 0, 1, 2, false, new lib.botoes(), 3);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.btn_diferenciais},{t:this.btn_implantacoes},{t:this.btn_imagens},{t:this.btn_projeto},{t:this.btn_localizacao},{t:this.btn_capa},{t:this.btn_plantas},{t:this.btn_institucional},{t:this.btn_video},{t:this.btn_tour}]}).wait(1));

	// MenuPseudoAfter
	this.instance_2 = new lib.pseudo_after();
	this.instance_2.setTransform(182.85,1010,0.9999,1,0,0,0,0.3,0);
	this.instance_2.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1));

	// MenuMarker
	this.occ_menu_marker = new lib.menu_marker();
	this.occ_menu_marker.name = "occ_menu_marker";
	this.occ_menu_marker.setTransform(349.95,1080);
	this.occ_menu_marker.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,-1,3);

	this.timeline.addTween(cjs.Tween.get(this.occ_menu_marker).wait(1));

	// MenuTitle
	this.instance_3 = new lib.CachedBmp_61();
	this.instance_3.setTransform(437.65,1030.9,0.5,0.5);

	this.instance_4 = new lib.CachedBmp_60();
	this.instance_4.setTransform(1740.6,1024.3,0.5,0.5);

	this.instance_5 = new lib.CachedBmp_59();
	this.instance_5.setTransform(1561.5,1024.3,0.5,0.5);

	this.instance_6 = new lib.CachedBmp_58();
	this.instance_6.setTransform(1391.2,1024.3,0.5,0.5);

	this.instance_7 = new lib.CachedBmp_57();
	this.instance_7.setTransform(1267.85,1024.3,0.5,0.5);

	this.instance_8 = new lib.CachedBmp_56();
	this.instance_8.setTransform(1145.75,1024.3,0.5,0.5);

	this.instance_9 = new lib.CachedBmp_55();
	this.instance_9.setTransform(964.15,1024.3,0.5,0.5);

	this.instance_10 = new lib.CachedBmp_54();
	this.instance_10.setTransform(799.6,1024.3,0.5,0.5);

	this.instance_11 = new lib.CachedBmp_53();
	this.instance_11.setTransform(622.4,1024.3,0.5,0.5);

	this.instance_12 = new lib.CachedBmp_52();
	this.instance_12.setTransform(456.2,1024.3,0.5,0.5);

	this.instance_13 = new lib.CachedBmp_51();
	this.instance_13.setTransform(359.9,1024.3,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_13},{t:this.instance_12},{t:this.instance_11},{t:this.instance_10},{t:this.instance_9},{t:this.instance_8},{t:this.instance_7},{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3}]}).wait(1));

	// MenuBackground
	this.occ_menu_background = new lib.menu_background();
	this.occ_menu_background.name = "occ_menu_background";
	this.occ_menu_background.setTransform(0,1080);

	this.timeline.addTween(cjs.Tween.get(this.occ_menu_background).wait(1));

	// background
	this.occ_background = new lib.background();
	this.occ_background.name = "occ_background";
	this.occ_background.setTransform(960,500,1,1,0,0,0,960,500);
	this.occ_background.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.occ_background).wait(1));

	// BackgroundDynamic
	this.occ_background_dynamic = new lib.background_dynamic();
	this.occ_background_dynamic.name = "occ_background_dynamic";

	this.timeline.addTween(cjs.Tween.get(this.occ_background_dynamic).wait(1));

	// ColorsPalette
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill().beginStroke("#252525").setStrokeStyle(1,1,1).moveTo(-46.9,-219.4).lineTo(46.9,-219.4).lineTo(46.9,-125.6).lineTo(-46.9,-125.6).closePath().moveTo(-46.9,-104.4).lineTo(46.9,-104.4).lineTo(46.9,-10.6).lineTo(-46.9,-10.6).closePath().moveTo(-46.9,125.6).lineTo(46.9,125.6).lineTo(46.9,219.4).lineTo(-46.9,219.4).closePath().moveTo(-46.9,10.6).lineTo(46.9,10.6).lineTo(46.9,104.4).lineTo(-46.9,104.4).closePath();
	this.shape.setTransform(-111.45,219.4);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.beginFill("#B49F6C").beginStroke().moveTo(-46.9,46.9).lineTo(-46.9,-46.9).lineTo(46.9,-46.9).lineTo(46.9,46.9).closePath();
	this.shape_1.setTransform(-111.45,391.9);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.beginFill("#142E29").beginStroke().moveTo(-46.9,46.9).lineTo(-46.9,-46.9).lineTo(46.9,-46.9).lineTo(46.9,46.9).closePath();
	this.shape_2.setTransform(-111.45,276.9);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.beginFill("#FFFFFF").beginStroke().moveTo(-46.9,46.9).lineTo(-46.9,-46.9).lineTo(46.9,-46.9).lineTo(46.9,46.9).closePath();
	this.shape_3.setTransform(-111.45,46.9);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.beginFill("#F5F3D6").beginStroke().moveTo(-46.9,46.9).lineTo(-46.9,-46.9).lineTo(46.9,-46.9).lineTo(46.9,46.9).closePath();
	this.shape_4.setTransform(-111.45,161.9);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_4},{t:this.shape_3},{t:this.shape_2},{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = p = new lib.AnMovieClip();
p.nominalBounds = new cjs.Rectangle(800.7,539,1120.3,638);
// library properties:
lib.properties = {
	id: '7C9EF5D5AF5D5F46AFF0D236F6A9A88F',
	width: 1920,
	height: 1080,
	fps: 30,
	color: "#FFFFFF",
	opacity: 1.00,
	manifest: [
		{src:"./images/CachedBmp_61.png", id:"CachedBmp_61"},
		{src:"./images/index_atlas_1.png", id:"index_atlas_1"}
	],
	preloads: []
};



// bootstrap callback support:

(lib.Stage = function(canvas) {
	createjs.Stage.call(this, canvas);
}).prototype = p = new createjs.Stage();

p.setAutoPlay = function(autoPlay) {
	this.tickEnabled = autoPlay;
}
p.play = function() { this.tickEnabled = true; this.getChildAt(0).gotoAndPlay(this.getTimelinePosition()) }
p.stop = function(ms) { if(ms) this.seek(ms); this.tickEnabled = false; }
p.seek = function(ms) { this.tickEnabled = true; this.getChildAt(0).gotoAndStop(lib.properties.fps * ms / 1000); }
p.getDuration = function() { return this.getChildAt(0).totalFrames / lib.properties.fps * 1000; }

p.getTimelinePosition = function() { return this.getChildAt(0).currentFrame / lib.properties.fps * 1000; }

an.bootcompsLoaded = an.bootcompsLoaded || [];
if(!an.bootstrapListeners) {
	an.bootstrapListeners=[];
}

an.bootstrapCallback=function(fnCallback) {
	an.bootstrapListeners.push(fnCallback);
	if(an.bootcompsLoaded.length > 0) {
		for(var i=0; i<an.bootcompsLoaded.length; ++i) {
			fnCallback(an.bootcompsLoaded[i]);
		}
	}
};

an.compositions = an.compositions || {};
an.compositions['7C9EF5D5AF5D5F46AFF0D236F6A9A88F'] = {
	getStage: function() { return exportRoot.stage; },
	getLibrary: function() { return lib; },
	getSpriteSheet: function() { return ss; },
	getImages: function() { return img; }
};

an.compositionLoaded = function(id) {
	an.bootcompsLoaded.push(id);
	for(var j=0; j<an.bootstrapListeners.length; j++) {
		an.bootstrapListeners[j](id);
	}
}

an.getComposition = function(id) {
	return an.compositions[id];
}


an.makeResponsive = function(isResp, respDim, isScale, scaleType, domContainers) {		
	var lastW, lastH, lastS=1;		
	window.addEventListener('resize', resizeCanvas);		
	resizeCanvas();		
	function resizeCanvas() {			
		var w = lib.properties.width, h = lib.properties.height;			
		var iw = window.innerWidth, ih=window.innerHeight;			
		var pRatio = window.devicePixelRatio || 1, xRatio=iw/w, yRatio=ih/h, sRatio=1;			
		if(isResp) {                
			if((respDim=='width'&&lastW==iw) || (respDim=='height'&&lastH==ih)) {                    
				sRatio = lastS;                
			}				
			else if(!isScale) {					
				if(iw<w || ih<h)						
					sRatio = Math.min(xRatio, yRatio);				
			}				
			else if(scaleType==1) {					
				sRatio = Math.min(xRatio, yRatio);				
			}				
			else if(scaleType==2) {					
				sRatio = Math.max(xRatio, yRatio);				
			}			
		}
		domContainers[0].width = w * pRatio * sRatio;			
		domContainers[0].height = h * pRatio * sRatio;
		domContainers.forEach(function(container) {				
			container.style.width = w * sRatio + 'px';				
			container.style.height = h * sRatio + 'px';			
		});
		stage.scaleX = pRatio*sRatio;			
		stage.scaleY = pRatio*sRatio;
		lastW = iw; lastH = ih; lastS = sRatio;            
		stage.tickOnUpdate = false;            
		stage.update();            
		stage.tickOnUpdate = true;		
	}
}
an.handleSoundStreamOnTick = function(event) {
	if(!event.paused){
		var stageChild = stage.getChildAt(0);
		if(!stageChild.paused || stageChild.ignorePause){
			stageChild.syncStreamSounds();
		}
	}
}
an.handleFilterCache = function(event) {
	if(!event.paused){
		var target = event.target;
		if(target){
			if(target.filterCacheList){
				for(var index = 0; index < target.filterCacheList.length ; index++){
					var cacheInst = target.filterCacheList[index];
					if((cacheInst.startFrame <= target.currentFrame) && (target.currentFrame <= cacheInst.endFrame)){
						cacheInst.instance.cache(cacheInst.x, cacheInst.y, cacheInst.w, cacheInst.h);
					}
				}
			}
		}
	}
}


})(createjs = createjs||{}, AdobeAn = AdobeAn||{});
